<template>
	<div class="iframe-box">
		<!-- frameborder属性：不设置边框，如果是vue2.x版本，那么可以使用src属性 -->
		<iframe src="plugins/download.html" width="100%" height="100%"
			class="iframe" id="tempHtml" ref="tempHtml" frameborder="0"></iframe>
	</div>
</template>

<script>
export default {
	name: "index",
	inject: ['WINDOW', 'F_alertMsg', 'F_windowLoading', 'F_getErrMSg', 'F_LOGIN', 'LOGINUSER'],
	data() {
		return {
			windowObj: this.WINDOW,
			loginUser: this.LOGINUSER,
		};
	},
	computed : {
		height (){

		}
	},
	mounted() {
		this.$options.methods.setHeight(this.$refs['tempHtml'])
	},
	created() {},
	methods: {
		setHeight: function(dom) {

		},
	}, watch: {
		windowObj: {
			handler(v) {
			},
			deep: true
		},
		loginUser: {
			handler() {
			},
			deep: true
		}
	}
}
</script>

<style scoped>
.iframe-box{
	/*position: fixed;*/
	/*top: 60px;*/
	/*bottom: 0;*/
	/*width: 100%;*/
	/*box-sizing: border-box;*/
}
.iframe{
	overflow-y: hidden;
	height: calc(100vh - 65px);
}
</style>